<template>
  <div class="service-form-part">
    <ServiceRadioField :choices="services" v-on="$listeners" />
  </div>
</template>

<script>
import { Selectable } from 'chimera/all/components/models/Selectable'
import ServiceRadioField from 'chimera/all/components/form/fields/service/ServiceRadioField.vue'
import {
  realEstateAppraisalNL,
  realEstatePurchaseNL,
  realEstateSalesNL,
} from 'chimera/realEstateAgency/service'

export default {
  name: 'ServiceRadioFormPart',

  components: {
    ServiceRadioField,
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      services: [
        new Selectable(
          'Ik wil een woning verkopen',
          'Ik wil een woning verkopen',
          realEstateSalesNL.id,
        ),
        new Selectable(
          'Ik wil een woning aankopen',
          'Ik wil een woning aankopen',
          realEstatePurchaseNL.id,
        ),
        new Selectable(
          'Ik wil een woning laten taxeren',
          'Ik wil een woning laten taxeren',
          realEstateAppraisalNL.id,
        ),
      ],
    }
  },
}
</script>
